import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { PixPaymentFavoredView } from '../models/payment-favored-view.model';
import { Observable } from 'rxjs';
import { PixTransferRequest } from '../models/transfer-request.model';
import { PixReceipt } from '../models/receipt.model';
import { BaseResult } from '../../../shared/models/base.result.model';
import { PixPaymentFavored } from '../models/payment-favored.model';
import { PixTransferReturn } from '../models/transfer-return.model';

@Injectable()
export class PixPaymentKeyService {
	private url = endpoints.pix;
	private selectedPixPaymentFavoredView: PixPaymentFavoredView;
	private selectedPixPaymentFavoredViewToDelete: PixPaymentFavoredView;
	private selectedPixReceipt: PixReceipt;

	constructor(private http: HttpClient) { }

	clearState(): void {
		this.selectedPixPaymentFavoredView = null;
	}

	postTransfer(model: PixTransferRequest): Observable<BaseResult<PixTransferReturn>> {
		return this.http.post<BaseResult<PixTransferReturn>>(`${this.url.transfer}`, model);
	}

	getInfoByCode(code: string): Observable<BaseResult<any>> {
		return this.http.post<BaseResult<any>>(`${this.url.qrcodeAccount}`, { Codigo: code });
	}

	getSelectedPixPaymentFavoredView = () => this.selectedPixPaymentFavoredView;
	setSelectedPixPaymentFavoredView = (pixPaymentFavoredView: PixPaymentFavoredView) => this.selectedPixPaymentFavoredView = pixPaymentFavoredView;
	getSelectedPixPaymentFavoredViewToDelete = () => this.selectedPixPaymentFavoredViewToDelete;
	setSelectedPixPaymentFavoredViewToDelete = (pixPaymentFavoredView: PixPaymentFavoredView) => this.selectedPixPaymentFavoredViewToDelete = pixPaymentFavoredView;
	getSelectedPixReceipt = () => this.selectedPixReceipt;
	setSelectedPixReceipt = (pixReceipt: PixReceipt) => this.selectedPixReceipt = pixReceipt;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/payment-key.service.ts